<template>
	<canvas ref="chart" :style="{'height': height + 'px'}"></canvas>
	
</template>

<script>
	import { Chart, registerables } from 'chart.js';
	Chart.register(...registerables);

	export default ({
		props: [
			'data',
			'height',
			'title',
			'titleEjeY',
		],
		data(){
			return {
				chart: null,
				resizeObserver: null,
			} ;
		},
		mounted () { 
    		let ctx = this.$refs.chart.getContext("2d");
			this.chart = new Chart(ctx, {
				type: "bar",
				data: this.data,
     			options: {
					datasets: {
						bar: {
							maxBarThickness: 60, // Ancho máximo de las barras
							barThickness: 'flex', // Ajuste flexible
							categoryPercentage: 0.8, // Porcentaje del espacio de categoría que ocupan las barras
							barPercentage: 0.6, // Porcentaje del espacio disponible que ocupa cada barra
						}
					},
					layout: {
						padding: {
							top: 0,
							right: 0,
							left: 0,
							bottom: 30,
						},
					},
					responsive: true,
					maintainAspectRatio: false,
					resizeDelay: 0,
					plugins: {
						legend: {
							display: false,
						},
						title: {
							display: true,
							text: this.title,
							// color: "#fff",
							font: {
								size: 12,
							},
							position: 'top',
						},

					},
					tooltips: {
						enabled: true,
						mode: "index",
						intersect: false,
					},
					scales: {
						y: {
							grid: {
								display: true,
								color: 'rgba(0,0,0,0.1)',
							},
							ticks: {
								padding: 8,
								display: true,
								font: {
									size: 12,
									lineHeight: 1.5,
									weight: '500',
									family: "Open Sans",
								},
							},
							title: {
								display: true,
								text: this.titleEjeY,
                                font: {
                                    size: 14,
                                    weight: '600',
                                    family: "Open Sans",
                                },
                                padding: {
                                    top: 0,
                                    bottom: 10
                                },
                                grid: {
                                    drawBorder: false
                                },
							},
							beginAtZero: true,
						},
						x: {
							grid: {
								display: true,
								color: 'rgba(0,0,0,0.1)',
							},
							ticks: {
								display: true,
								maxRotation: 0, // Evitar rotación de labels
								padding: 5,
								font: {
									size: 11,
									lineHeight: 1.2,
									weight: '500',
									family: "Open Sans",
								},
							},
						},
					},
				}
			});

			// Configurar ResizeObserver para detectar cambios de tamaño
			this.setupResizeObserver();
			
			// Forzar un resize inicial después de un pequeño delay
			this.$nextTick(() => {
				setTimeout(() => {
					if (this.chart) {
						this.chart.resize();
					}
				}, 100);
			});
		},

		watch: {
			data: {
				handler(newData) {
					if (this.chart && newData) {
						this.chart.data = newData;
						this.chart.update('resize');
						this.$nextTick(() => {
							this.chart.resize();
						});
					}
				},
				deep: true
			}
		},

		methods: {
			setupResizeObserver() {
				if (window.ResizeObserver && this.$refs.chart) {
					this.resizeObserver = new ResizeObserver(() => {
						if (this.chart) {
							// Usar requestAnimationFrame para evitar múltiples llamadas
							requestAnimationFrame(() => {
								if (this.chart) {
									this.chart.resize();
								}
							});
						}
					});
					this.resizeObserver.observe(this.$refs.chart.parentElement);
				}
			},

			handleResize() {
				if (this.chart) {
					this.chart.resize();
				}
			}
		},

		// Right before the component is destroyed,
		// also destroy the chart.
		beforeDestroy: function () {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
			if (this.chart) {
				this.chart.destroy();
			}
		},
	})

</script>

<style lang="scss" scoped>
.chart-bar-wrapper {
    margin: 0;
	padding: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
	line-height: 0; /* elimina espacios de texto */
	font-size: 0;   /* elimina espacios inline */
	display: flex;
	align-items: center;
	justify-content: center;
}

.chart-bar-wrapper canvas {
    margin: 0 auto !important;
    display: block !important;
    max-width: 100% !important;
    max-height: 100% !important;
    width: auto !important;
    height: auto !important;
}
</style>